module.exports = __webpack_public_path__ + "static/media/YM07_1.9dd78712.jpg";